import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import BinaryStateButton from "components/BinaryStateButton";
import { IconCollection } from "components/Icon/IconCollection";
import Tooltip from "components/Tooltip/Tooltip";
import { ActivityConfig, FeConfigType, RelationshipConfig, ResourceConfig } from "config/config";
import { ResourceDetails } from "containers/Resources/screens/ResourcesSingle/components/ResourceDetails/ResourceDetails";
import { isEmpty } from "lodash";
import { useState } from "react";

interface DetailsPopoverProps {
    resourceConfig: ResourceConfig | ActivityConfig | RelationshipConfig;
    resourceData?: any;
    resourceName: FeConfigType;
    isDisabled?: boolean;
    isFetching?: boolean;
    isGitEnabled?: boolean;
    iri?: string;
    fetchResourceData?: () => void;
    style?: React.CSSProperties;
    popoverClassName?: string;
}

export const DetailsPopover = ({
    resourceName,
    resourceData,
    isFetching,
    isDisabled,
    resourceConfig,
    isGitEnabled,
    iri,
    fetchResourceData,
    style,
    popoverClassName,
}: DetailsPopoverProps) => {
    const [detailsPopoverEl, setDetailsPopoverEl] = useState(null);

    return (
        <Tooltip overlay="Details" overlayStyle={style}>
            <BinaryStateButton
                trueStateIcon={IconCollection.informationOutline}
                falseStateIcon={IconCollection.informationOutline}
                trueStateColor="primary"
                state={Boolean(detailsPopoverEl)}
                onClick={(event) => {
                    setDetailsPopoverEl(event.target);
                }}
                className="detailsButton"
                disabled={isEmpty(resourceData)}
            />
            <Popover
                open={Boolean(detailsPopoverEl)}
                anchorEl={detailsPopoverEl}
                onClose={() => {
                    setDetailsPopoverEl(null);
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                className={popoverClassName}
            >
                <Box sx={{ p: 4 }}>
                    <ResourceDetails
                        resourceName={resourceName}
                        resourceData={resourceData}
                        isFetching={isFetching}
                        isDisabled={isDisabled}
                        resourceConfig={resourceConfig}
                        isRecordOrContainerGitEnabled={isGitEnabled}
                        iri={iri}
                        fetchResourceData={fetchResourceData}
                    />
                </Box>
            </Popover>
        </Tooltip>
    );
};
